<template>
  <div
    id="show-item"
    class="fixed z-50 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
        @click="hide"
      />

      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >&#8203;</span>

      <div
        v-if="item === null"
        class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl md:max-w-3xl w-full md:w-10/12 sm:p-6 text-center"
      >
        <i class="fa fa-spinner fa-spin text-2xl" />
      </div>
      <div
        v-else
        class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl md:max-w-3xl w-10/12 sm:p-6"
        :class="{'mt-24 md:mt-8' : user}"
      >
        <div class="absolute top-0 right-0 pt-4 pr-4">
          <button
            type="button"
            class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            @click="hide"
          >
            <span class="sr-only">Close</span>
            <i class="fal fa-times text-lg md:text-2xl" />
          </button>
        </div>

        <h3
          class="text-black font-bold block text-lg md:text-4xl"
          v-text="item.name"
        />

        <ul
          id="slider-big"
          class="my-6"
        >
          <li v-if="item.main_image_big">
            <img :src="item.main_image_big">
          </li>
          <li
            v-for="image in item.images_big"
            :key="image"
          >
            <img :src="image">
          </li>
        </ul>

        <ul
          id="slider-controls"
          class="relative"
        >
          <li class="prev absolute inset-y-0 left-0 top-8">
            <i class="fa fa-chevron-left" />
          </li>
          <li class="next absolute inset-y-0 right-0 top-8">
            <i class="fa fa-chevron-right" />
          </li>
        </ul>

        <ul
          id="slider-small"
          class="text-center mb-6"
        >
          <li
            v-if="item.main_image_small"
            class="w-16 md:w-24 inline-block text-center"
          >
            <img
              :src="item.main_image_small"
              class="m-auto "
            >
          </li>
          <li
            v-for="image in item.images_small"
            :key="image"
            class="w-16 md:w-24 inline-block text-center"
          >
            <img
              :src="image"
              class="m-auto "
            >
          </li>
        </ul>

        <p
          v-if="item.description_long && item.description_long !== ''"
          class="text-black font-bold"
        >
          Productomschrijving:
        </p>

        <!-- eslint-disable vue/no-v-html -->
        <p
          class="mt-2 content"
          v-html="item.description_long"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
  </div>
</template>

<script>
import {watchEffect} from 'vue';
import Modal from '../Mixins/Modal';

export default {
  mixins: [Modal],

  props: {
    item: {
      type: Object,
      required: false,
      default: () => null,
    },
  },

  emits: ['close'],

  data () {
    return {
      user: this.$page.props.user || null,
      slider: null,
    };
  },

  watch: {
    item: 'generateSlider',
  },

  methods: {
    generateSlider () {
      watchEffect(() => {
        if (!this.item.main_image_big) {
          return;
        }

        import('tiny-slider').then(({tns}) => {
          this.$nextTick(() => {
            if (this.slider) {
              this.slider.rebuild();
            } else {
              this.slider = tns({
                container: '#slider-big',
                items: 1,
                controlsContainer: '#slider-controls',
                navContainer: '#slider-small',
                navAsThumbnails: true,
                autoplay: true,
                autoplayButtonOutput: false,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                swipeAngle: false,
                speed: 400,
              });
            }
          });
        });
      }, []);
    },

    hide () {
      if (this.slider) {
        this.slider.destroy();
      }

      this.$nextTick(() => {
        this.$emit('close');
      });
    },
  },
};
</script>
